export const messages = {
  recoverUsername: 'Recover your username',
  contactUs: 'To recover your username contact us at',
  getBackSoon: "We'll get back to you soon",
  back: 'Back to login',
};
